import { useQueryClient } from '@tanstack/react-query'
import { useUpdateBot } from '../../hooks'
import { getQueryKey } from '~/services'
import { BotSummary } from '~/features/bots/types'

type Props = { botId: string; workspaceId: string; name: string; onSuccess?: () => void }

export function useRenameBot() {
  const queryClient = useQueryClient()
  const { mutate: updateBot, ...rest } = useUpdateBot()

  const renameBot = ({ botId, workspaceId, name, onSuccess }: Props) => {
    return updateBot({
      id: botId,
      workspaceId,
      name,
      onSuccess: () => {
        const botQueryKey = getQueryKey('workspaces_/$workspaceId_/bots_/$botId_', { botId, workspaceId })
        queryClient.setQueryData(botQueryKey, (prev: BotSummary) => ({
          ...prev,
          name,
        }))
        onSuccess?.()
      },
    })
  }

  return { mutate: renameBot, ...rest }
}
